import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AskExpertListComponent } from './components/ask-expert-list/ask-expert-list.component';
import { ErrorLogsListComponent } from './components/error-logs-list/error-logs-list.component';
import { FaqComponent } from './components/faq/faq.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ProfileDetailComponent } from './components/profile-detail/profile-detail.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SupportComponent } from './components/support/support.component';
import { AskExpertSaveComponent } from './components/ask-expert-save/ask-expert-save.component';
import { ProfilePage } from './profile.page';
import { MyDevicesComponent } from './components/my-devices/my-devices.component';
import { DeviceDetailComponent } from './components/device-detail/device-detail.component';
import { UserManualComponent } from './components/user-manual/user-manual.component';

const routes: Routes = [
  {
    path: '',
    component: ProfilePage
  },
  {
    path: 'detail',
    component: ProfileDetailComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'settings',
    component: SettingsComponent
  },
  {
    path: 'notifications',
    component: NotificationsComponent
  },
  {
    path: 'error-log',
    component: ErrorLogsListComponent
  },
  {
    path: 'my-devices',
    component: MyDevicesComponent
  },
  {
    path: 'my-devices-detail',
    component: DeviceDetailComponent
  },
  {
    path: 'user-manual',
    component: UserManualComponent
  },
  {
    path: 'support',
    children: [
      {
        path: '',
        component: SupportComponent
      },
      {
        path: 'ask-expert',
        component: AskExpertListComponent
      },
      {
        path: 'ask-expert-detail',
        component: AskExpertSaveComponent
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfilePageRoutingModule { }
